// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"3041b486","294":"0cd11734"}[chunkId] + ".chunk.css";
};